export default {
    'this-double-visit-report' : 'هذا التقرير المزدوج',
    'add-new-report': 'إضافة تقرير جديد'
}